'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var topFromWindow = function topFromWindow(element) {
  if (typeof element === 'undefined' || !element) return 0;

  return (element.offsetTop || 0) + topFromWindow(element.offsetParent);
};

exports.default = topFromWindow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtual-list/lib/utils/topFromWindow.js
// module id = 774
// module chunks = 1